import { type AppLanguageCode, type TKey, translateApp } from '@/lib/i18n'

/**
 * Request-scoped translator for the public site. i18next is a global singleton
 * whose `language` is not request-scoped during SSR, so public pages resolve
 * copy through `translateApp(appLanguage, key)` with the language taken from the
 * route context (set in `__root` `beforeLoad`). Build one per render:
 * `const t = createSiteTranslate(appLanguage)`.
 */
export function createSiteTranslate(appLanguage: AppLanguageCode) {
	return (key: TKey) => translateApp(appLanguage, key)
}
